import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/scl90";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllScl90ByTax(params.tratamientoId);
}

export function Scl90List(props) {
  const [scl90List, setScl90] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllScl90ByTax(props.id).then(setScl90).catch(console.log);
  }, [props.id]);
  return (
    <>
      {scl90List?.length ? (
        <ul className="scl90 cpt-list">
          {scl90List
            .sort((a, b) => {
              // Parse the dates from the meta objects
              const dateA = new Date(a.meta.metaFecha);
              const dateB = new Date(b.meta.metaFecha);
              // Compare the dates (descending order)
              return dateB - dateA;
            })
            .map((scl90) => (
              <li key={scl90.id}>
                <NavLink to={`${props.id}/cuestionarios/scl-90/${scl90.id}`}>
                  {`${FormatDate(scl90.meta.metaFecha)}`}
                </NavLink>
              </li>
            ))}
        </ul>

          ) : (
            <></>
          )}
    </>
  );
}



export function Scl90ListContent() {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id="content">
        <h1>SCL-90</h1>
      </div>
      <div id="actions">
        {<Link className="button is-link" to={`new`}>Nuevo</Link>}
      </div>
    </>
  );
}